import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { CourtBookingEventPlayerModel } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-court-booking-players',
    templateUrl: './court-booking-players.component.html',
    styleUrls: ['./court-booking-players.component.scss'],
    standalone: false
})
export class CourtBookingPlayersComponent implements OnInit {
    @Input() players: Array<CourtBookingEventPlayerModel>;

    @Output() onChangePlayerClicked: EventEmitter<any> = new EventEmitter();
    @Output() onCheckInPlayerClicked: EventEmitter<any> = new EventEmitter();

    constructor() { }

    ngOnInit(): void { }

    changePlayer(personId: string) {
        this.onChangePlayerClicked.emit(personId);
    }

    checkInPlayer(personId: string) {
        this.onCheckInPlayerClicked.emit(personId);
    }

    public canShowChangePlayer(player: CourtBookingEventPlayerModel): boolean {
        return !player.isBookingOwner && player.isChangePlayerAvailable;
    }
}
